/* global axios */

import ApiClient from './ApiClient';

class PrivateCommandAPI extends ApiClient {
  constructor() {
    super('private_commands', { accountScoped: true });
  }

  get({ searchKey }) {
    const url = searchKey ? `${this.url}?search=${searchKey}` : this.url;
    return axios.get(url);
  }
}

export default new PrivateCommandAPI();
